import Vue from 'vue'

export default {
  initFunc() {
    /**
     * type: value  1品牌认证中；2品牌已认证；3品牌认证失败；4认证已过期；品牌未认证
     * */
    Vue.filter ('certFilter', function(type) {
      if(type === '1'){
        return '品牌认证中'
      }else if(type === '2'){
        return '品牌已认证'
      }else if(type === '3'){
        return '品牌认证失败'
      }else if(type === '4'){
        return '认证已过期'
      }else {
        return '品牌未认证'
      }
    })
    /**
     * type: value  1产品；2半成品；3原料；4设备；5采销品；6其他 7 代理
     * */
    Vue.filter('goodsType', function (value) {
      switch (value) {
        case 1:
          return '产品'
        case 2:
          return '半成品'
        case 3:
          return '原料'
        case 4:
          return '设备'
        case 5:
          return '采销'
        case 6:
          return '其他'
        case 7:
          return '代理'
        default :
          return '自有'
      }
    }),
      /**
       * orderStatus: 订单状态过滤器  //无奈
       * pay_type:  1为支付宝，2为微信，3为银联 4网页支付宝 5公众号支付  6支付宝扫码支付 7微信扫码支付；8协议付款;9公众号溯源支付
       * pay_status:  支付状态      1为未支付，2为支付成功，3为逾期未支付（支付失败）
       * shipping_status:  物流状态  1为初始状态（未进入发货流程），2为待发货，3为待收货（也称为已发货），4为用户确认收货
       * order_status: 1为初始状态（未付款），2为未付款被买家取消，3为未付款被卖家取消 ，4为已付款（商家待确认, 舍弃该状态），
       *     5为已付款被买家取消，6已付款被卖家取消，7为商家确认（已支付成功才能确认），8为已完成（必须支付成功并且买家确认收货），9为售后状态
       * aftersale_status:  售后状态  1为初始状态（未进入售后流程）， 2为售后中， 3全部退款 4部分退款
       * refund_return:  退货退款状态:0是无退款,1有退款
       * comment_type:  退货退款状态:0是无评论,1有评论
       *
       * */
      Vue.filter('orderStatus', function (data) {
        var statusName = ''
        data.order_status = data.order_status ? data.order_status : '1'
        data.shipping_status = data.shipping_status ? data.shipping_status : '1'
        if (data.order_status === 1) {
          statusName = '未付款'
        } else if (data.order_status === 2 || data.order_status === 3) {
          statusName = '已取消'
        } else if (data.order_status === 5) {
          statusName = '已取消'
        } else if (data.order_status === 6) {
          statusName = '已取消'
        } else if (data.order_status === 7) {
          if (data.shipping_status === 1) {
            statusName = '已付款'
          } else if (data.shipping_status === 2) {
            statusName = '待发货'
          } else if (data.shipping_status === 3 || data.shipping_status === 4) {
            statusName = '已发货'
          } else {
            statusName = '已付款'
          }
        } else if (data.order_status === 8) {
          statusName = '已完成'
        } else if (data.order_status === 9) {
          statusName = '已发货'
        } else {
          statusName = '未付款'
        }
        return statusName
      })

    /**
     * 订单操作说明
     *  status； 1 未付款  2 已取消  3 已付款 代发货  4 已付款 物流状态中   5 已完成确认收货  6 已评价
     * */
    Vue.prototype.orderOperation = function (data) {
      let status = 1
      data.order_status = data.order_status ? data.order_status : 1
      data.shipping_status = data.shipping_status ? data.shipping_status : 1
      if (data.order_status === 1) {
        status = 1
      } else if (data.order_status === 2 || data.order_status === 3 || data.order_status === 5 || data.order_status === 6) {
        status = 2
      } else if (data.order_status === 7 && (data.shipping_status === 1 || data.shipping_status === 2)) {
        status = 3
      } else if (data.order_status === 7 && (data.shipping_status === 3 || data.shipping_status === 4)) {
        status = 4
      } else if (data.order_status === 8) {
        status = 5
      } else if (data.order_status === 9) {
        status = 4
      }
      if (data.is_comment) {
        status = 6
      }
      return status
    }
    /**
     * 订单售后状态
     * status； 1 申请退款  2  退款待审核  3 退款成功  4 退款失败  5 申请售后  6 退货待审核  7 退货中  8 退货成功  8 退货失败
     *          9 退款失败
     *
     *  `refund_return`：0 无退款 1 有退款  此状态要先判断是否有退款
     * `order_status` 1 未付款  2 已取消  3 已付款 代发货 4 已付款 物流状态中   5 已完成确认收货
     * `refund_type` int(1) NOT NULL DEFAULT '1' COMMENT '申请类型: 1为退款, 2为退货退款,',
     * `refund_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '申请状态:1为处理中,2已完成,3为取消退款,默认为1',
     * `seller_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '卖家处理状态:1为待审核,2为同意,3为不同意,默认为1',
     * `return_status` int(1) NOT NULL DEFAULT '1' COMMENT '退货状态:1无需退货,2待买家发货,3待卖家收货,4未收到,5已收到',
     * `goods_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '商品物流状态:1为待发货,2为待收货,3为未收到,4为已收货,默认为1',
     *
     * */
    Vue.prototype.refundStatus = function (data) {
      let status = ''
      data.refund_status = data.refund_status ? data.refund_status : ''
      data.seller_status = data.seller_status ? data.seller_status : ''
      if (data.order_status >= 3) {
        if (data.goods_status === 1 && data.order_status === 3) {
          if (data.refund_return === 0) {
            status = 1
          } else {
            if (data.refund_type === 1 && (data.refund_status === 1 )) {
              status = 2
            } else if (data.refund_type === 1 && (data.refund_status === 3)) {
              status = 1
            } else if (data.refund_type === 1 && (data.refund_status === 2 && data.seller_status === 2)) {
              status = 3
            } else if (data.refund_type === 1 && (data.refund_status === 2 || data.seller_status === 3)) {
              status = 4
            }
          }
        } else {
          if (data.refund_return === 0) {
            status = 5
          } else {
            if (data.refund_type === 1 && (data.refund_status === 1 || data.seller_status === 1)) {
              status = 2
            } else if (data.refund_type === 1 && (data.refund_status === 2 && data.seller_status === 2)) {
              status = 3
            } else if (data.refund_type === 1 && (data.refund_status === 2 || data.seller_status === 3)) {
              status = 4
            }
            if (data.refund_type === 2 && (data.refund_status === 1 || data.seller_status === 1)) {
              status = 6
            } else if (data.refund_type === 2 && (data.refund_status === 2 && data.seller_status === 2 && (data.return_status === 2 || data.return_status === 3))) {
              status = 7
            } else if (data.refund_type === 2 && (data.refund_status === 2 && data.seller_status === 2 && data.return_status === 5)) {
              status = 8
            } else if (data.refund_type === 2 && (data.return_status === 4 || data.seller_status === 3)) {
              status = 9
            }
          }
        }
      }
      return status
    }
    /**
     * 订单售后状态
     * status； 1 申请退款  2  退款待审核  3 退款成功  4 退款失败  5 申请售后  6 退货待审核  7 退货中  8 退货成功  8 退货失败
     *
     *  `refund_return`：0 无退款 1 有退款  此状态要先判断是否有退款
     * `order_status` 1 未付款  2 已取消  3 已付款 代发货 4 已付款 物流状态中   5 已完成确认收货
     * `refund_type` int(1) NOT NULL DEFAULT '1' COMMENT '申请类型: 1为退款, 2为退货退款,',
     * `refund_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '申请状态:1为处理中,2已完成,3为取消退款,默认为1',
     * `seller_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '卖家处理状态:1为待审核,2为同意,3为不同意,默认为1',
     * `return_status` int(1) NOT NULL DEFAULT '1' COMMENT '退货状态:1无需退货,2待买家发货,3待卖家收货,4未收到,5已收到',
     * `goods_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '商品物流状态:1为待发货,2为待收货,3为未收到,4为已收货,默认为1',
     *
     * */
    Vue.prototype.refundStatusName = function (data) {
      let status = ''
      data.refund_status = data.refund_status ? data.refund_status : ''
      data.seller_status = data.seller_status ? data.seller_status : ''
      if (data.refund_type === 1) {
        if (data.refund_status === 1 || data.seller_status === 1) {
          status = '退款中'
        } else if (data.refund_status === 2 && data.seller_status === 2) {
          status = '退款成功'
        } else if (data.refund_status === 2 || data.seller_status === 3) {
          status = '退款失败'
        }
      } else if (data.refund_type === 2) {
        if (data.refund_status === 1 || data.seller_status === 1) {
          status = '退货待审核'
        } else if (data.refund_status === 2 && data.seller_status === 2 && (data.return_status === 2 || data.return_status === 3)) {
          status = '退货中'
        } else if (data.refund_status === 2 && data.seller_status === 2 && data.return_status === 5) {
          status = '退货成功'
        } else if (data.return_status === 4 || data.seller_status === 3) {
          status = '退货失败'
        }
      }
      return status
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/comm/vue.extend.js